class Banner {
	constructor() {

	}
}